import axios from '../util/axiosConfig';

export const fetchVisitsRoasterAPI = async (payload) => {
    return await axios.get(`/api/v1/receptionist/visit-roster`, {
        params: {
            ...payload
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false }
    })
}

export const cancelAppointmentEventAPI = async (appointmentId, eventId) => {
    return await axios.get(`/api/v1/receptionist/cancel-appointment-event`,
        {
            params: {
                appointmentId: appointmentId,
                eventId: eventId
            }
        },
    ).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false };
        }
    })
        .catch(function (error) {
            return { success: false };
        });
}

export const submitClaimForVisit = async (visitId,resubmit) => {
    const reSubmitted = resubmit? resubmit: false
    return await axios.get(`/api/auth/generate-claim-for-visit`, {
        params: {
            visitId,
            reSubmitted
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false }
    })
}

export const settleClaimAPI = async (payload) => {
    return await axios.post(`/api/v1/settle-claim`, payload)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const settleVisitPayment = async (visitId,resubmit) => {
    const reSubmitted = resubmit? resubmit: false
    return await axios.get(`/api/auth/generate-claim-for-visit`, {
        params: {
            visitId,
            reSubmitted
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false }
    })
}

export const addUpdateVisitNote = async (payload) => {
    return await axios.post(`/api/v1/add-visit-notes`, payload)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const addUpdateQuickCode = async (payload) => {
    return await axios.post(`/api/v1/add-update-quick-code`, payload)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const deleteQuickCodeExamination = async (quickCodeItemId, quickCodeId) => {
    return await axios.delete(`/api/v1/delete-quick-code-examination`, {
        params: {
            quickCodeItemId,
            quickCodeId
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const fetchCancelledVisitsAPI = async (payload) => {
    return await axios.get(`/api/v1/visits/cancelled`, {
        params: {
            ...payload
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false }
    })
}

export const reinstateVisitAPI = async (visitNo) => {    
    return await axios.put(`/api/v1/visits/reinstate?visitNo=${visitNo}`)
        .then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false }
    })
}

export const cancelVisitAPI = async (visitId) => {
    return await axios.get(`/api/v1/cancel-visit`, {
        params: {
            visitId
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false }
    })
}